<template>
  <div>
    <!-- 创建授权按钮 -->
    <el-button class="base-margin__bottom-10" type="primary" @click="openDialog">
      {{ $t('authorization.createAuthorization') }}
    </el-button>

    <!-- 授权列表表格 -->
    <div class="table">
      <el-table :data="tableData" class="table_width">
        <!-- 表格列定义 -->
        <el-table-column :label="$t('authorization.userName')" prop="userInfo.name"></el-table-column>
        <el-table-column :label="$t('authorization.applicationName')">
          <template slot-scope="scope">
            {{ filterAppName(scope.row.applicationId) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('authorization.createTime')" prop="createTime"></el-table-column>
        <el-table-column :label="$t('authorization.expirationTime')">
          <template slot-scope="scope">
            {{ disposeTime(scope.row.expiresAt) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('authorization.operation')" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="editImage(scope.row)">
              {{ $t('authorization.edit') }}
            </el-button>
            <el-button type="text" @click="deleteImage(scope.row.id)">
              {{ $t('authorization.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <el-pagination
        :page-size="10"
        :page-sizes="[10, 20, 50, 100]"
        :total="tableDataTotal"
        align="right"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="onCurrentChange"
      />
    </div>

    <!-- 授权编辑对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form ref="formLabelAlign" :model="formLabelAlign" label-width="140px">
        <!-- 用户选择 -->
        <el-form-item :label="$t('authorization.userId')" prop="userId">
          <el-select v-model="formLabelAlign.userId" :placeholder="$t('authorization.selectUser')">
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <!-- 应用选择 -->
        <el-form-item :label="$t('authorization.applicationId')" prop="applicationId">
          <el-select v-model="formLabelAlign.applicationId" :placeholder="$t('authorization.selectApplication')">
            <el-option
              v-for="item in applicationIdList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <!-- 授权周期或过期时间 -->
        <el-form-item v-if="dialogType === 'add'" :label="$t('authorization.authorizationPeriod')" prop="period">
          <el-select v-model="formLabelAlign.period" :placeholder="$t('authorization.selectAuthorizationPeriod')">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-else :label="$t('authorization.expirationTime')" prop="expiresAt">
          <el-date-picker
            v-model="formLabelAlign.expiresAt"
            :placeholder="$t('authorization.selectExpirationTime')"
            format="yyyy-MM-dd"
            style="width: 100%"
            type="date"
          />
        </el-form-item>
      </el-form>

      <!-- 对话框底部按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createCode">
          {{ $t('authorization.confirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getRequest, postRequest} from '@/common/libs/request';
import {Message} from 'element-ui';
import dayjs from 'dayjs';
import {debounce} from '@/common/utils/utils';

export default {
  name: 'configManagement',
  data() {
    return {
      tableData: [], // 用户应用授权列表
      dialogTitle: this.$t('authorization.createAuthorization'), // 对话框标题
      dialogVisible: false, // 对话框显示状态
      formLabelAlign: { // 表单数据
        applicationId: '',
        expiresAt: '',
        period: '',
      },
      dialogType: 'add', // 对话框类型(add/edit)
      pageIndex: 1, // 当前页码
      pageLimit: 10, // 每页条数
      tableDataTotal: 0, // 数据总数
      options: [], // 授权周期选项,
      userList: [], // 用户列表
      applicationIdList: [], // 应用列表
    };
  },
  created() {
    this.options = [ // 授权周期选项
      {value: 1, label: this.$t('authorization.oneMonth')},
      {value: 3, label: this.$t('authorization.threeMonths')},
      {value: 6, label: this.$t('authorization.halfYear')},
      {value: 12, label: this.$t('authorization.oneYear')},
      {value: 24, label: this.$t('authorization.twoYears')}
    ];
    // 初始化数据
    this.getList();
    this.getUserList();
    this.getAvailableApplicationsList();
  },
  methods: {
    /**
     * 打开授权对话框
     */
    openDialog() {
      this.dialogType = 'add';
      this.dialogTitle = this.$t('authorization.createAuthorization');
      this.formLabelAlign = {
        applicationId: '',
        expiresAt: '',
        period: '',
      };
      this.dialogVisible = true;
    },

    /**
     * 获取用户授权列表
     */
    getList() {
      const offset = this.pageLimit * (this.pageIndex - 1);
      getRequest(`/api/eda/common/admin/getUserLicenseList?offset=${offset}&limit=${this.pageLimit}`).then((res) => {
        res.list.forEach((item) => {
          item.expiresAt = item.expiresAt * 1000;
        });
        this.tableData = res.list;
        this.tableDataTotal = res.total;
      });
    },

    /**
     * 获取用户列表
     */
    getUserList() {
      getRequest('/api/eda/common/admin/getUserList?offset=0&limit=999').then((res) => {
        this.userList = res.list;
      });
    },

    /**
     * 获取应用列表
     */
    getAvailableApplicationsList() {
      getRequest('/api/eda/common/admin/describeAvailableApplications?offset=0&limit=999').then((res) => {
        this.applicationIdList = res.applicationList;
      });
    },

    /**
     * 格式化时间显示
     * @param {Number} val - 时间戳
     * @returns {String} 格式化后的时间字符串
     */
    disposeTime(val) {
      return dayjs(val).format('YYYY-MM-DD hh:mm:ss');
    },

    /**
     * 根据应用ID获取应用名称
     * @param {Number} id - 应用ID
     * @returns {String} 应用名称
     */
    filterAppName(id) {
      let value = '';
      const filter = this.applicationIdList.filter(item => item.id === id);
      if (filter.length !== 0) {
        value = filter[0].name;
      }
      return value;
    },

    /**
     * 创建/更新授权
     */
    createCode() {
      this.formLabelAlign.applicationId = +this.formLabelAlign.applicationId;
      debounce(() => {
        if (this.dialogType === 'add') {
          postRequest('/api/eda/common/admin/createUserLicense', this.formLabelAlign).then(() => {
            Message.success(this.$t('authorization.createSuccess'));
            this.dialogVisible = false;
            this.getList();
          });
        } else {
          const data = {
            applicationId: this.formLabelAlign.applicationId,
            expiresAt: +this.formLabelAlign.expiresAt / 1000,
            id: this.formLabelAlign.id,
            userId: this.formLabelAlign.userId,
          };
          postRequest('/api/eda/common/admin/updateUserLicense', data).then(() => {
            Message.success(this.$t('authorization.updateSuccess'));
            this.dialogVisible = false;
            this.getList();
          });
        }
      }, 500);
    },

    /**
     * 编辑授权
     * @param {Object} e - 行数据
     */
    editImage(e) {
      this.dialogTitle = this.$t('authorization.editAuthorization');
      this.dialogType = 'edit';
      this.formLabelAlign = Object.assign({}, e);
      this.dialogVisible = true;
    },

    /**
     * 删除授权
     * @param {Number} id - 授权ID
     */
    deleteImage(id) {
      this.$confirm(
        this.$t('authorization.confirmDelete'),
        this.$t('authorization.deleteAuthorization'),
        {
          confirmButtonText: this.$t('authorization.confirm'),
          cancelButtonText: this.$t('authorization.cancel'),
        }
      ).then(() => {
        postRequest('/api/eda/common/admin/deleteUserLicense', {id: +id}).then(() => {
          this.getList();
          Message.success(this.$t('authorization.deleteSuccess'));
        });
      });
    },

    /**
     * 分页页码变化处理
     * @param {Number} val - 当前页码
     */
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },

    /**
     * 分页每页条数变化处理
     * @param {Number} val - 每页条数
     */
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.table_width {
  width: 100%;
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.spanCls {
  width: 50px;
  line-height: 40px;
}
</style>
